import React from "react";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";

import { AutoHeaderSpacer } from "../_layout-helpers/auto-header-spacer";
import { optToMaybe } from "../../utils/fp/small-fp-utils";
import { head } from "fp-ts/es6/Array";
import { ComponentRenderer } from "../_layout-helpers/component-renderer";
import { Spacer } from "../../components/_shared-components/arrangement/Space";
import { HeaderComponent } from "../../components/HeaderComponent/HeaderComponent";
import { FooterComponent } from "../../components/FooterComponent/FooterComponent";
import { PageMetadataComponent } from "../../components/PageMetadataComponent/PageMetadataComponent";
import { ExtractSwarovskiPageData } from "@swo/storefront";
import { ProductFamilyPageData } from "@swo/storefront";
import { useStore } from "../../store/hooks/use-store";
import { t2 } from "../../domain/translations/translations";

export const ProductFamilyPageLayout: ReactTFC<ExtractSwarovskiPageData<ProductFamilyPageData>> = props => {
  const { locationOrigin } = useStore().state;
  const gt = t2(props.generalTranslations);

  return (
    <>
      <PageMetadataComponent
        {...props.data.metadata}
        locationOrigin={locationOrigin}
        canonicalPath={props.page.path}
        languageIsoCode={props.locale.language.isoCode}
      />

      <HeaderComponent header={props.data.header} version={"normal"} />
      <AutoHeaderSpacer
        componentAfterHeaderTypeName={optToMaybe(
          head(props.data.components.map(c => (typeof c === "string" ? undefined : c.__typename))),
        )}
      />

      <ComponentRenderer components={props.data.components} localeForNumberFormat={props.locale} translations={gt} />

      <Spacer size={"md"} />
      <FooterComponent {...props.data.footer} />
    </>
  );
};
